export default __webpack_public_path__ + "static/404-image-2c211a6b39cdac888305fb9a410ea0a1.png";